
import axiosInstance from './axiosInstance';


export const createUserAssignment = async (assignmentData) => {
  try {
    const response = await axiosInstance.post('/assign/create', assignmentData);
    return response.data;
  } catch (error) {
    console.error('Error creating user assignment:', error);
    throw error;
  }
};
